import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ArticoliService, PrezzoArticolo } from 'src/app/servizi/articoli.service';

import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-prezzi-articolo-listino',
  templateUrl: './prezzi-articolo-listino.component.html',
  styleUrls: ['./prezzi-articolo-listino.component.scss'],
})
export class PrezziArticoloListinoComponent implements OnInit {

  @Input() prezzo: PrezzoArticolo
  @Input() listinoSelezionato: string;
  @Input() codiceArticolo: string;

  fg: FormGroup;

  constructor(public translate: TranslateService,private articoliService: ArticoliService, private modalCtrl: ModalController, private fb: FormBuilder) { }

  ngOnInit() {
    this.fg = this.fb.group({
      listino: [this.prezzo.LISTINO]
    })
  }

  close(){
    this.modalCtrl.dismiss()
  }

  async modifica(){
    await this.articoliService.setPrezzoArticolo(this.codiceArticolo, this.listinoSelezionato, this.prezzo.COMB, this.prezzo.PREZZO, this.fg.get('listino').value, this.prezzo.DISTINTA)
    this.close()
  }

}
